import { HTMLProps, forwardRef } from 'react'

export type PriceInputProps = Omit<HTMLProps<HTMLInputElement>, 'type'> & {
  label?: string
  labelClassName?: string
  error?: string
  prefix?: string
}

export const PriceInput = forwardRef<HTMLInputElement, PriceInputProps>(
  ({ label, labelClassName, error, className, prefix = '$', ...props }, ref) => {
    return (
      <div className="flex flex-col gap-y-2 w-full">
        {label && (
          <span className={`text-white text-sm font-semibold ${labelClassName ? labelClassName : ''}`}>{label}</span>
        )}
        <div
          className={`bg-white ${
            props.disabled && '!bg-slate-300'
          } p-3 md:p-[17px] border border-navy-900 border-opacity-20 rounded-full flex items-center gap-x-3`}
        >
          <span className="text-navy-900 placeholder:text-opacity-50 text-sm">{prefix}</span>
          <input
            ref={ref}
            placeholder="0.00"
            type="number"
            min={0}
            onWheel={(e: any) => e.target.blur()}
            {...props}
            className={`focus:outline-none text-navy-900 w-full text-sm ${
              props.disabled && '!bg-slate-300 opacity-30'
            } ${className}`}
          />
        </div>
        {error && <div className="text-boldOrange pt-1 font-medium">{error}</div>}
      </div>
    )
  }
)
